import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { TalabatLogFilterForm, TalabatLogTable } from 'components/logsTalabat'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { FILTER_FIELD_TALABAT_LOG } from 'components/logsTalabat/talabatLogFilterForm'
import { FilterMeta } from 'utils/helpers'
import { Button } from 'components/common'
import { ExportIcon } from 'components/icons'
import { downloadTalabatLogs } from 'utils/api/logsApi'
import { useQuery } from 'hooks'

const TalabatLogs = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()
  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = getQuery(FILTER_FIELD_TALABAT_LOG)

      await downloadTalabatLogs(logFilter || undefined)
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Talabat Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Talabat Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_TALABAT_LOG} />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      <TalabatLogFilterForm filterMeta={filterMeta} />
      <TalabatLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default TalabatLogs
